import { render } from "./Per.vue?vue&type=template&id=3a6a7a7c&scoped=true"
import script from "./Per.vue?vue&type=script&lang=js"
export * from "./Per.vue?vue&type=script&lang=js"

import "./Per.vue?vue&type=style&index=0&id=3a6a7a7c&scoped=scoped&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6a7a7c"]])

export default __exports__